<template>
  <myDialog
      :isDialog="isDialog"
      :title="type==1 ? '新增黑名单' : '编辑黑名单'"
      :width="'800px'"
      @handleClose="handleClose"
  >
    <template #content>
      <el-form ref="formRef" :model="formData" :rules="rules" label-width="170px" class="add-case-form">
<!--        <el-form-item label="名单类型" prop="applicationYear">-->
<!--          <el-select v-model="formData.applicationYear" placeholder="请选择名单类型">-->
<!--            <el-option v-for="item in backWhiteTypeList" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"/>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item label="类型" prop="list">
          <el-select v-model="formData.list" placeholder="请选择类型">
            <el-option v-for="item in userTypeList" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"/>
          </el-select>
        </el-form-item>
        <el-form-item :label="formData.list==1?'单位名称':'个人姓名'" prop="name">
          <el-input v-model="formData.name" placeholder="请输入" />
        </el-form-item>
        <el-form-item :label="formData.list==1?'统一社会信用代码':'身份证号'" prop="identification">
          <el-input v-model="formData.identification" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="列入原因" prop="cause">
          <el-input v-model="formData.cause" type="textarea" placeholder="请输入列入原因" />
        </el-form-item>
      </el-form>
    </template>
    <template #footer>
      <template>
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</el-button>
      </template>
    </template>
  </myDialog>
</template>

<script>
import { getListByDictType } from '@/api/sys/dictData'
import { addBlackList, updateBlackList } from '@/api/recognition/blackList'
export default {
  name: "blackAndWhiteAdd",
  props: {
    type: {
      type: Number,
      default: 1
    },
    isDialog: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      formData: {
        listType:2,
        name: '',
        identification: '',
        cause: ''
      },
      rules: {
        list: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入姓名或单位名称', trigger: 'blur' }
        ],
        identification: [
          { required: true, message: '请输入身份证号或统一社会信用代码', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (this.formData.list == 1) {
              if (!/^[0-9A-Za-z]{18}$/.test(value)) {
                callback(new Error('请输入正确的统一社会信用代码'))
              } else {
                callback()
              }
            } else {
              if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)){
                callback(new Error('请输入正确的身份证号'))
              } else {
                callback()
              }
            }
          }, trigger: 'blur' }
        ],
        cause: [
          { required: true, message: '请输入列入原因', trigger: 'blur' }
        ]
      },
      submitLoading: false,
      backWhiteTypeList:[],
      userTypeList:[]
    }
  },
  created() {
    this.loadDict()
  },
  methods: {
    handleClose() {
      this.$emit('handleClose')
    },
    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
            this.submitLoading = true
            if(this.type==1){
              addBlackList(this.formData).then(res => {
                if (res && res?.code === 200) {
                  this.$message.success('新增成功')
                  this.$emit('handleClose', true)
                }
              }).finally(() => {
                this.submitLoading = false
              })
            }else{
              delete this.formData.createTime
              updateBlackList(this.formData).then(res => {
                if (res && res?.code === 200) {
                  this.$message.success('修改成功')
                  this.$emit('handleClose', true)
                }
              }).finally(() => {
                this.submitLoading = false
              })
            }
        }
      })
    },
    loadDict(){
      getListByDictType('black_white_type').then(res => {
        this.backWhiteTypeList = res.data
      })
      getListByDictType('black_white_user_type').then(res => {
        this.userTypeList = res.data
      })
    }
  },
  mounted() {
    if(this.type==2){
      this.formData = this.rowData
      this.formData.list=String(this.rowData.list)
    }
  }
}
</script>

<style scoped>
/deep/ .el-dialog__header {
  background: #297dee !important;
}
/deep/ .el-dialog__title {
  color: #ffffff !important;
  font-weight: 700;
  font-size: 17px;
}
/deep/ .el-dialog__headerbtn {
  filter: brightness(0) invert(1) !important;
}
</style>